// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import LabeledCriteria from '../../../../shared/components/labeled-criteria';

const CreditMemoWorkOrderCriteria = props =>
    <div className='credit-memo-work-order-criteria'>
        <LabeledCriteria
            className='work-order-criteria'
            isRequired={false}
            label={props.label}
            maxLength='17'
            onInputChange={props.handleInputChange}
            placeholder={props.placeHolderText}
            type='text'
            value={props.value}
        />
    </div>;

CreditMemoWorkOrderCriteria.displayName = 'CreditMemoWorkOrderCriteria';
CreditMemoWorkOrderCriteria.propTypes = {
    handleInputChange: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
    placeHolderText: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
};

export default CreditMemoWorkOrderCriteria;




// WEBPACK FOOTER //
// ./src/reports/credit-memo/components/credit-memo-report-criteria/work-order-criteria.js